import { Component, ojs, app, each, v } from "modular-openscriptjs";
import {
	fireEvent,
	monetary,
	showActionButton,
	scrollToTop,
	pageInfo,
	oneOf,
} from "../../../helpers";
import { PAGES } from "../../../declarations";
import BsIcon from "../../Blocks/BsIcon";

const h = app("h");
const uc = app("uc");
const $e = app("$e");

ojs(BsIcon);

export default class PlaceOrder extends Component {
	render(...args) {
		pageInfo(PAGES.FINALIZE_ORDER);
		scrollToTop();

		let deliveryFee =
			uc.logisticsCompany.delivery_fee_per_vehicle[uc.fleetType.value] ??
			0;
		let subtotal = 0;

		each(uc.cart.value, (item) => {
			subtotal += Number(item.qty) * Number(item.price);
		});

		return h.div(
			{ class: "py-md-5" },
			h.div(
				{ class: "row g-4" },
				h.div(
					{ class: "col-md-8" },
					h.div(
						{ class: "card border-0 shadow-sm rounded-4 p-4 mb-3" },
						h.h5({ class: "fw-bold mb-3" }, "Order Notes"),
						h.div(
							{ class: "mb-0" },
							h.textarea(
								{
									class: "form-control border-0 bg-light rounded-3 p-3 text-secondary border-focus-primary",
									id: "order-notes",
									rows: "4",
									oninput: this.method(
										"saveOrderNotes",
										"${this}"
									),
									placeholder:
										"Notes for the deliverer or businesses to see...",
								},
								oneOf(uc.orderNotes, "")
							)
						)
					)
				),

				v(uc.settings, (settings) => {
					return h.SettingItem(settings.value?.fill_up_prices, {
						class: "mb-4",
					});
				}),

				h.div(
					{ class: "col-md-4" },
					h.div(
						{
							class: "card border-0 shadow-lg rounded-4 p-4 sticky-top",
							style: "top: 100px; z-index: 10;",
						},
						h.div(
							{
								class: "d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom",
							},
							h.h5({ class: "fw-bold mb-0" }, "Order Summary")
						),

						h.div(
							{ class: "d-flex flex-column gap-3" },
							h.div(
								{
									class: "d-flex justify-content-between align-items-center",
								},
								h.span({ class: "text-secondary" }, "Subtotal"),
								h.span(
									{ class: "fw-semibold" },
									monetary(
										subtotal,
										window.userCurrency ?? "KES"
									)
								)
							),
							h.div(
								{
									class: "d-flex justify-content-between align-items-center",
								},
								h.span(
									{ class: "text-secondary" },
									"Delivery Fee"
								),
								h.span(
									{ class: "fw-semibold" },
									monetary(
										deliveryFee,
										window.userCurrency ?? "KES"
									)
								)
							),
							h.div({ class: "border-top my-1" }),
							h.div(
								{
									class: "d-flex justify-content-between align-items-center",
								},
								h.span({ class: "h5 fw-bold mb-0" }, "Total"),
								h.span(
									{ class: "h4 fw-bold text-primary mb-0" },
									monetary(
										deliveryFee + subtotal,
										window.userCurrency ?? "KES"
									)
								)
							)
						)
					)
				)
			),

			...args
		);
	}

	saveOrderNotes(elem) {
		uc.orderNotes = elem.value;
	}

	$_rendered_rerendered(...args) {
		this.showPlaceOrderBtn();
	}

	showPlaceOrderBtn() {
		setTimeout(() => {
			let ele = h.span(
				{
					class: "d-flex align-items-center justify-content-between gap-2",
				},
				h.span(
					{ class: "d-flex gap-2 align-items-center" },
					h.BsIcon("cart-check"),
					h.span("Place Order")
				),
				h.i({ class: "fas fa-arrow-right" })
			);

			showActionButton((Action, callbackId) => {
				fireEvent($e.order.needs.placement);
				Action.closeForm();
			}, ele.outerHTML);
		}, 500);
	}

	$$order = {
		has: {
			placementError: () => this.showPlaceOrderBtn(),
		},
	};
}

ojs(PlaceOrder);
